import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import * as bi from 'react-bootstrap-icons';
import { ApiError, ApiErrorCode } from '@bustickus/api';
import { IClientTicketFull } from '@bustickus/models-client';
import { ApiTickets } from 'common/api';
import { handleAuthError } from 'common/handlers';
import { Button, Flex } from 'components';
import { ModalLoader, PageSidebar, ScrollFiller, TicketStatus } from 'shared/components';
import { DownloadCard, PassegnerCard, RefundCard, TicketCard, TripCard, PaymentCard } from './components';

function PageTicket() {
  const [ticket, setTicket] = useState<IClientTicketFull | null>(null);
  const { ticketId } = useParams();

  useEffect(() => {
    loadTicketData();
  }, []);

  const loadTicketData = async () =>
    await handleAuthError(async () => {
      if (ticketId == null) {
        throw new ApiError(ApiErrorCode.NotFound, 'Ticket Id Not Found!');
      }

      const api = ApiTickets.getInstance();
      const ticket = await api.get(ticketId);
      setTicket(ticket);
    });

  const handleReloadClick = () => {
    setTicket(null);
    loadTicketData();
  };

  return (
    <PageSidebar
      title='Билет'
      frameTitle='Информация о билете'
    >
      {ticket == null && <ModalLoader />}

      {ticket != null && (
        <Flex
          direction='column'
          gap={10}
        >
          <Flex
            justifyContent='space-between'
            alignItems='flex-end'
          >
            <TicketStatus
              status={ticket.status}
              price={ticket.price}
            />

            <Button
              onClick={handleReloadClick}
              color='transparent-blue'
              size='small'
            >
              <Flex
                gap={5}
                alignItems='center'
              >
                <bi.ArrowClockwise />
                <span>Обновить</span>
              </Flex>
            </Button>
          </Flex>

          <TicketCard ticket={ticket} />
          <DownloadCard ticket={ticket} />
          {ticket.trip != null && <TripCard trip={ticket.trip} />}
          {ticket.passenger != null && (
            <PassegnerCard
              passenger={ticket.passenger}
              trip={ticket.trip}
            />
          )}
          {ticket.payment != null && <PaymentCard payment={ticket.payment} />}
          <RefundCard
            ticket={ticket}
            onRefund={handleReloadClick}
          />
          <ScrollFiller />
        </Flex>
      )}
    </PageSidebar>
  );
}

export default PageTicket;
